import React, { useEffect, useState, createElement } from 'react';
import { TopBanner } from './components/TopBanner';
import { NavBar } from './components/NavBar';
import { PopNotification } from './components/PopNotification';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ForYourBabySection } from './components/ForYourBabySection';
import { SolutionSection } from './components/SolutionSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueStackSection } from './components/ValueStackSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ShareSection } from './components/ShareSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { Modal } from './components/Modal';
import { UpsellPopup } from './components/UpsellPopup';
import { PrivacyPolicyContent, TermsOfServiceContent, DisclaimerContent } from './components/ModalContent';
type ModalType = 'privacy' | 'terms' | 'disclaimer' | null;
export function App() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const [showUpsell, setShowUpsell] = useState(false);
  useEffect(() => {
    // Facebook Pixel - Replace YOUR_PIXEL_ID with your real Pixel ID
    const pixelId = '1466073988306169';
    const f = window as any;
    if (!f.fbq) {
      const n = (f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    f.fbq('init', pixelId);
    f.fbq('track', 'PageView');
    f.fbq('track', 'ViewContent');
  }, []);
  const handleOpenModal = (modalId: ModalType) => {
    setOpenModal(modalId);
  };
  const handleCloseModal = () => {
    setOpenModal(null);
  };
  const handleBuyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowUpsell(true);
  };
  return <div className="w-full min-h-screen" data-id="element-0">
      <TopBanner data-id="element-1" />
      <NavBar onBuyClick={handleBuyClick} data-id="element-2" />
      <PopNotification data-id="element-3" />
      <HeroSection onBuyClick={handleBuyClick} data-id="element-4" />
      <ForYourBabySection data-id="element-5" />
      <ProductSection onBuyClick={handleBuyClick} data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <PainSection data-id="element-8" />
      <SolutionSection data-id="element-9" />
      <ValueStackSection onBuyClick={handleBuyClick} data-id="element-10" />
      <TestimonialsSection data-id="element-11" />
      <GuaranteeSection onBuyClick={handleBuyClick} data-id="element-12" />
      <FAQSection data-id="element-13" />
      <ShareSection data-id="element-14" />
      <FinalCTASection onBuyClick={handleBuyClick} data-id="element-15" />
      <Footer onOpenModal={handleOpenModal} data-id="element-16" />

      <UpsellPopup isOpen={showUpsell} onClose={() => setShowUpsell(false)} data-id="element-17" />

      <Modal isOpen={openModal === 'privacy'} onClose={handleCloseModal} title="Privacy Policy" data-id="element-18">
        <PrivacyPolicyContent data-id="element-19" />
      </Modal>

      <Modal isOpen={openModal === 'terms'} onClose={handleCloseModal} title="Terms of Service" data-id="element-20">
        <TermsOfServiceContent data-id="element-21" />
      </Modal>

      <Modal isOpen={openModal === 'disclaimer'} onClose={handleCloseModal} title="Disclaimer" data-id="element-22">
        <DisclaimerContent data-id="element-23" />
      </Modal>
    </div>;
}